export default __webpack_public_path__ + "static/media/illustration_district-map.90b94efa.svg";